import { css } from 'styled-components';

export const resetCss = css`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  ::-webkit-scrollbar {
    width: 1rem;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--scroll-color);
    border-radius: 1.25rem;
    border: 0.375rem solid transparent;
    background-clip: content-box;
  }

  body {
    font-weight: 500;
  }

  img {
    display: block;
  }

  /* AntD 4 centers the zoomed preview image with inline-block + vertical-align;
     the global \`img { display: block }\` above breaks that and drops the image to
     the bottom-left corner. Restore inline-block for the preview image only. */
  .ant-image-preview-img {
    display: inline-block;
  }
`;
